import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLeaf,
  faLightbulb,
  faUsers,
  faAward,
  faChartLine,
  faGlobe,
  faHandshake,
  faRocket,
  faTrophy,
  faShieldAlt,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import SEO from './SEO';

const About = () => {
  return (
    <div className="about">
      <SEO
        title="About CoreNova | Renewable Energy Experts"
        description="Learn about CoreNova’s mission, leadership, and commitment to clean, efficient, reliable renewable energy solutions."
        canonical="https://corenovarenewable.com/about"
        image="https://corenovarenewable.com/images/2.png"
        keywords="about corenova, renewable energy company, leadership, mission, vision"
      />
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="/images/about hero.png"
            alt="Corenova Agency Pvt Ltd Hero Background"
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
        </div>

        {/* Content */}
        <div className="container relative z-10">
          <div className="max-w-4xl mx-auto space-y-6">
            <h1 className="text-4xl md:text-6xl font-bold animate-fade-in text-white drop-shadow-2xl shadow-black">
              About Corenova Renewable Energies Pvt Ltd
            </h1>
            <p className="text-xl md:text-2xl animate-fade-in text-white drop-shadow-xl shadow-black font-semibold" style={{ animationDelay: '0.2s' }}>
              Leading the renewable energy revolution with innovative solutions and sustainable practices
            </p>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="section bg-white">
        <div className="container">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <h2 className="text-4xl md:text-5xl font-bold text-dark">Our Story</h2>
              <div className="space-y-6 text-lg text-gray leading-relaxed">
                <p>Welcome to Corenova Renewable. As a company, our story is about much more than
                  solar panels; it is about making a cleaner, more sustainable Odisha. We are a
                  movement of innovators, engineers, and passionate advocates who believe that clean
                  energy should be available to everyone.
                </p>
                <p>
                  Founded in 2024 as part of the Corenova Group, we started with one straightforward
                  idea: we wanted to change how we power our lives. We noticed the rising costs of
                  traditional energy and the growing need for climate action. We were ready to take the
                  chance and make a commitment to renewable energy. We wanted to change the way
                  solar energy delineates itself in Bhubaneswar/i.e., More Quality, More Genuine, More…
                  Whatever it may be, we are determined to change it!

                </p>
                <p>
                  Today, we are proud to have completed over 500 renewable energy projects. Well, this
                  is not a number; this is proof of the trust placed in us by clients whose lives we have
                  changed! Some of those projects may mean even more to us in terms of our
                  determination to remain committed to you and to quality. Every home and business we
                  help is another step to a brighter and greener future for all of us.

                </p>
              </div>

              <div className="grid grid-cols-3 gap-6">
                <div className="text-center p-6 bg-gray-light rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-lg">
                  <div className="text-3xl font-bold text-primary-green mb-2">1+</div>
                  <div className="text-sm text-gray">Years of Experience</div>
                </div>
                <div className="text-center p-6 bg-gray-light rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-lg">
                  <div className="text-3xl font-bold text-primary-green mb-2">500+</div>
                  <div className="text-sm text-gray">Projects Completed</div>
                </div>
                <div className="text-center p-6 bg-gray-light rounded-2xl hover:-translate-y-2 transition-all duration-300 hover:shadow-lg">
                  <div className="text-3xl font-bold text-primary-green mb-2">50MW</div>
                  <div className="text-sm text-gray">Energy Generated</div>
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              <div className="w-80 h-80 bg-gradient-to-br from-primary-green-lighter to-secondary-blue-light rounded-full flex flex-col items-center justify-center text-white shadow-2xl">
                <FontAwesomeIcon icon={faLeaf} className="text-6xl mb-4" />
                <p className="text-xl font-semibold">Sustainable Future</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
   <section className="section bg-gray-light">
  <div className="container">
    <div className="grid md:grid-cols-2 gap-12">
      <div className="card group">
        <div className="w-20 h-20 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
          <FontAwesomeIcon icon={faRocket} className="text-3xl text-white" />
        </div>
        <h3 className="text-2xl font-bold text-dark mb-6">Our Mission</h3>
        <p className="text-gray leading-relaxed">
          Our mission is to make it possible for homeowners and businesses to a cleaner future
          with innovative, dependable, affordable solar solutions. We want to be the vehicle that
          moves Odisha toward renewable energy
        </p>
      </div>

      <div className="card group">
        <div className="w-20 h-20 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
          <FontAwesomeIcon icon={faGlobe} className="text-3xl text-white" />
        </div>
        <h3 className="text-2xl font-bold text-dark mb-6">Our Vision</h3>
        <p className="text-gray leading-relaxed">
          Our vision is a world where clean energy can power everything. Our goal is to make
          solar energy accessible, affordable, and available to everyone, so every community,
          every home, and every business may thrive on 100% clean energy.
        </p>
      </div>
    </div>
  </div>
</section>

{/* Why Choose Corenova Section */}
<section className="section bg-white">
  <div className="container">
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-6">Why Choose Corenova?</h2>
      <p className="text-xl text-gray-700 max-w-3xl mx-auto">
        We recognize that you have options. Which is what we have grown our company on
        trust, expertise and humanness.
      </p>
    </div>
    
    <div className="grid md:grid-cols-3 gap-8">
      <div className="card group text-center">
        <div className="w-20 h-20 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
          <FontAwesomeIcon icon={faAward} className="text-3xl text-white" />
        </div>
        <h3 className="text-2xl font-bold text-dark mb-4">Certified and Licensed</h3>
        <p className="text-gray leading-relaxed">
          We have fully licensed and certified professionals who are leaders in the industry. 
          Your project is in the hands of an expert every step of the way.
        </p>
      </div>
      
      <div className="card group text-center">
        <div className="w-20 h-20 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
          <FontAwesomeIcon icon={faTrophy} className="text-3xl text-white" />
        </div>
        <h3 className="text-2xl font-bold text-dark mb-4">Award Winning Service</h3>
        <p className="text-gray leading-relaxed">
          We have been honored with top awards in the industry which speaks volumes about 
          the quality of service we provide and our commitment to excellence.
        </p>
      </div>
      
      <div className="card group text-center">
        <div className="w-20 h-20 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300">
          <FontAwesomeIcon icon={faShieldAlt} className="text-3xl text-white" />
        </div>
        <h3 className="text-2xl font-bold text-dark mb-4">Best in Odisha</h3>
        <p className="text-gray leading-relaxed">
          We've earned our reputation through transparency, quality craftsmanship, and genuine care. 
          We're not just installing panels; we're building relationships.
        </p>
      </div>
    </div> 
  </div>
</section>

      {/* Values */}
      <section className="section bg-white">
        <div className="container">
          <div className="section-title">
            <h2>Our Core Values</h2>
            <p>The principles that guide our every decision and action</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="card group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faLeaf} className="text-2xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-4">Sustainability</h4>
              <p className="text-gray leading-relaxed">We are committed to environmental protection and sustainable development in everything we do.</p>
            </div>

            <div className="card group">
              <div className="w-16 h-16 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faLightbulb} className="text-2xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-4">Innovation</h4>
              <p className="text-gray leading-relaxed">We continuously explore and implement cutting-edge technologies to deliver the best solutions.</p>
            </div>

            <div className="card group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faUsers} className="text-2xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-4">Excellence</h4>
              <p className="text-gray leading-relaxed">We strive for excellence in every project, ensuring the highest quality standards and customer satisfaction.</p>
            </div>

            <div className="card group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faHandshake} className="text-2xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-4">Integrity</h4>
              <p className="text-gray leading-relaxed">We conduct our business with honesty, transparency, and ethical practices at all times.</p>
            </div>

            <div className="card group">
              <div className="w-16 h-16 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faChartLine} className="text-2xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-4">Growth</h4>
              <p className="text-gray leading-relaxed">We are committed to continuous learning, improvement, and growth for our team and clients.</p>
            </div>

            <div className="card group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faAward} className="text-2xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-4">Quality</h4>
              <p className="text-gray leading-relaxed">We maintain the highest standards of quality in our products, services, and customer support.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section bg-gray-light">
        <div className="container">
          <div className="section-title">
            <h2>Our Leadership Team</h2>
            <p>Behind every successful project, there is a team of tracking and dedicated people. We
want you to meet the professionals who will help make the magic happen. From the
founders to the on-site technicians, each member of Corenova is dedicated to you and
your success.
</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
            <div className="card text-center group">
              <div className="w-24 h-24 bg-gradient-to-r from-primary-green to-primary-green-light rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faUsers} className="text-3xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-2"> BALARAM BAGARTY </h4>
              <p className="text-primary-green font-semibold mb-4">CEO & Founder</p>
              <p className="text-gray leading-relaxed">
                A visionary leader with over two decades of expertise in entrepreneurship, sustainability, development, innovation, and business growth who is committed to shaping impactful, future-ready solutions bridging innovation with practical execution.
              </p>
            </div>

            <div className="card text-center group">
              <div className="w-24 h-24 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faUsers} className="text-3xl text-white" />
              </div>
              <h4 className="text-xl font-bold text-dark mb-2">NIRANJAN KHILAR</h4>
              <p className="text-primary-green font-semibold mb-4">Director & Manager</p>
              <p className="text-gray leading-relaxed">
                Recognized for the ability to anticipate market shifts and translate them into strategic opportunities, he combines technical excellence with business acumen to deliver impactful projects in the renewable energy sector.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="section bg-white">
        <div className="container">
          <div className="section-title">
            <h2>Certifications & Awards</h2>
            <p>All our hard work is backed up and confirmed by professional bodies, we are proud to
be certified by many organizations, and it shows our respect for professionalism and
quality.
</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="card text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faAward} className="text-2xl text-white" />
              </div>
              <h4 className="text-lg font-bold text-dark mb-2">Approved</h4>
              <p className="text-gray text-sm">MNRE Approved</p>
            </div>

            <div className="card text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-secondary-blue to-secondary-blue-dark rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faAward} className="text-2xl text-white" />
              </div>
              <h4 className="text-lg font-bold text-dark mb-2">BIS-Certified</h4>
              <p className="text-gray text-sm">BIS-Certified</p>
            </div>

            <div className="card text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faAward} className="text-2xl text-white" />
              </div>
              <h4 className="text-lg font-bold text-dark mb-2"> Renewable Energy Company 2025</h4>
              <p className="text-gray text-sm"></p>
            </div>

            <div className="card text-center group">
              <div className="w-16 h-16 bg-gradient-to-r from-primary-green to-primary-green-light rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <FontAwesomeIcon icon={faAward} className="text-2xl text-white" />
              </div>
              <h4 className="text-lg font-bold text-dark mb-2">Green Business Certification</h4>
              <p className="text-gray text-sm">Environmental Leadership</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 